import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { createScoped as higherOrder } from '../../extenders';
function createScoped(scope) {
    return higherOrder(scope)(this);
}
AnalyticsDispatcher.prototype.createScoped = createScoped;
//# sourceMappingURL=createScoped.js.map